module.exports = __webpack_public_path__ + "images/sprites/ui/icon_phone_093ef834cde4cac6124948faa85a00df.png";